import useDebouncedEffect from 'hooks/useDebouncedEffect';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { activeNetworkSelector } from 'redux/selectors';
import { useGetJobsQuery } from 'services/jobsV2';

export const useJobForList = () => {
  const [keywords, setKeywords] = useState();
  const [debouncedKeywords, setDebouncedKeywords] = useState();
  const [page, setPage] = useState(1);
  const activeNetwork = useSelector(activeNetworkSelector);
  const [companyId, setCompanyId] = useState();

  const {
    data: jobData,
    isFetching: isFetchingJobs,
    error: jobError,
  } = useGetJobsQuery({
    page,
    perPage: 20,
    filters: {
      q: debouncedKeywords,
      includeMatchesLists: true,
      status: 'active',
      companyId,
    },
  });

  useDebouncedEffect(
    () => {
      setDebouncedKeywords(keywords);
    },
    600,
    keywords,
  );

  const normalizedJobData = jobData
    ? jobData.map((job) => ({
        organization: job.organization,
        job: { id: job.id, title: job.title },
        matches: (job.sharedLists || []).map((list) => ({
          ...list,
          url: `/networks/${activeNetwork.slug}/list/${list.id}/contacts`,
        })),
        matchLists: { id: null, status: job.status || 'none' },
        network: activeNetwork,
      }))
    : [];

  return {
    isLoadingJobs: isFetchingJobs,
    jobs: jobData,
    search: setKeywords,
    searchResults: keywords || !normalizedJobData.length ? normalizedJobData : normalizedJobData,
    showEmptyState: jobData?.data?.length === 0,
    error: jobError,
    keywords,
    loadMore: () => {
      if (jobData?.hasMore) {
        setPage(page + 1);
      }
    },
    companyId,
    setCompanyId,
  };
};
